import { Loading } from 'ui/Loading/Loading'
import { SoftwareList } from 'features/software-list/SoftwareList'

import { useSoftwareListQuery } from '../software-list/hooks'

type Props = {
  indexCategory: 'mostPopular'
  label: string
}

export const IndexPageCategory = ({ label }: Props) => {
  const softwareQuery = useSoftwareListQuery({ limit: 12, status: 'enabled' })
  if (softwareQuery.isLoading) return <Loading />
  const software = softwareQuery.data ?? []
  return (
    <div className="relative w-full">
      <h1 className="text-2xl font-light grow mb-2">
        <div className="w-fit">{label}</div>
      </h1>

      <div className="flex flex-row gap-x-5 w-full">
        <SoftwareList software={software} />
      </div>
    </div>
  )
}
